export default __webpack_public_path__ + "static/media/icon_park_outline_transaction_inactive_new.22f17065.svg";